module.exports = __webpack_public_path__ + "static/introvid-c48e33d8175eb101afb8a986e94bc831.mp4";